import { render } from "./AssistantPicker.vue?vue&type=template&id=67e8ed7c&scoped=true"
import script from "./AssistantPicker.vue?vue&type=script&lang=js"
export * from "./AssistantPicker.vue?vue&type=script&lang=js"

import "./AssistantPicker.vue?vue&type=style&index=0&id=67e8ed7c&lang=scss&scoped=true"

import exportComponent from "/build/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67e8ed7c"]])

export default __exports__